import React from "react";
import { useHistory } from "react-router-dom";
import {
  IntegrateFMsgContainer,
  StyledSolvingProblemsIlustrationContainer,
  StyledInnerIntegrateFMsg,
} from "../dashboard.style";
import { ReactComponent as SolvingProblems } from "../../../img/SolvingProblems.svg";

const IntegrateFBMsg = () => {
  const history = useHistory();

  return (
    <IntegrateFMsgContainer>
      <StyledSolvingProblemsIlustrationContainer>
        <SolvingProblems />
      </StyledSolvingProblemsIlustrationContainer>
      <StyledInnerIntegrateFMsg>
        <h3>Facebook Audiences</h3>
        <p>Connect Fixel with your Facebook Ads account for simple audience management</p>
        <button
          type="button"
          onClick={() => {
            history.push("/setup/facebook");
          }}>
          Integrate
        </button>
      </StyledInnerIntegrateFMsg>
    </IntegrateFMsgContainer>
  );
};
export default IntegrateFBMsg;
